module.exports = __webpack_public_path__ + "static/media/03.7d40251e.jpg";